import React from 'react';
import styled from '@emotion/styled';

export const CLOSE_BUTTON_CLASS_NAME = 'close-button';

export default (props: { onClick?: () => any }) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    if (props.onClick) {
      props.onClick();
    }

    event.stopPropagation();
  };

  return (
    <StyledCloseButtonContainer
      onClick={handleClick}
      className={CLOSE_BUTTON_CLASS_NAME}
    >
      ×
    </StyledCloseButtonContainer>
  );
};

export const StyledCloseButtonContainer = styled.button`
  display: block;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  border: 0;
  outline: 0;
  font-size: 24px;
  border-radius: 50%;
  cursor: pointer;
  width: 30px;
  height: 30px;
`;
